import React, { memo } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Checkbox,
    Button,
} from '@mui/material';

const displayEmails = (arr) =>
    Array.isArray(arr) ? arr.join(', ') : 'N/A';

const ChangedTrackersDialog = ({
    open,
    changedTrackers,
    rollbackSelection,
    onClose,
    onRollbackAll,
    onRollbackSelect,
    onRollbackRequest,
}) => {
    const allSelected =
        rollbackSelection.length === changedTrackers.length &&
        changedTrackers.length > 0;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xl"
            PaperProps={{ style: { minHeight: '80vh' } }}
        >
            <DialogTitle>Trackers Updated</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    The following trackers were changed by your last operation. Select
                    those you want to rollback:
                </Typography>

                <TableContainer component={Paper} sx={{ mb: 2 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        onChange={onRollbackAll}
                                        checked={allSelected}
                                    />
                                </TableCell>
                                <TableCell>UIN</TableCell>
                                <TableCell>Old Owner(s)</TableCell>
                                <TableCell>Old Manager(s)</TableCell>
                                <TableCell>Old Reviewer(s)</TableCell>
                                <TableCell>New Owner(s)</TableCell>
                                <TableCell>New Manager(s)</TableCell>
                                <TableCell>New Reviewer(s)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {changedTrackers.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No changed trackers
                                    </TableCell>
                                </TableRow>
                            ) : (
                                changedTrackers.map((tracker) => {
                                    const {
                                        uniqueIdentifier,
                                        oldOwnerEmails,
                                        oldManagerEmails,
                                        oldReviewerEmails,
                                        newOwnerEmails,
                                        newManagerEmails,
                                        newReviewerEmails,
                                    } = tracker;

                                    const checked =
                                        rollbackSelection.includes(uniqueIdentifier);

                                    return (
                                        <TableRow key={uniqueIdentifier}>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={checked}
                                                    onChange={() =>
                                                        onRollbackSelect(uniqueIdentifier)
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>{uniqueIdentifier}</TableCell>
                                            {/* Old assignments */}
                                            <TableCell>
                                                {displayEmails(oldOwnerEmails)}
                                            </TableCell>
                                            <TableCell>
                                                {displayEmails(oldManagerEmails)}
                                            </TableCell>
                                            <TableCell>
                                                {displayEmails(oldReviewerEmails)}
                                            </TableCell>
                                            {/* New assignments */}
                                            <TableCell>
                                                {displayEmails(newOwnerEmails)}
                                            </TableCell>
                                            <TableCell>
                                                {displayEmails(newManagerEmails)}
                                            </TableCell>
                                            <TableCell>
                                                {displayEmails(newReviewerEmails)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit" variant="outlined">
                    Close
                </Button>
                <Button
                    onClick={onRollbackRequest}
                    variant="contained"
                    color="error"
                >
                    Rollback
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default memo(ChangedTrackersDialog);
